<script>
import gql from "graphql-tag";
import { onLogin } from "../vue-apollo";
import provider from "../libs/provider";
export default {
	apollo: {
		settings: {
			query: gql`
				{
					Settings {
						has_completed_wizard
						connected
					}
				}
			`,
			update: r => r.Settings
		}
	},

	mounted() {
		if (this.$route.query.code || provider.get().providerCode === "msft") {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation ExchangeThirdPartyAuthCode($code: String!) {
							ExchangeThirdPartyAuthCode(code: $code)
						}
					`,
					variables: {
						code: this.$route.query.code || ""
					},
					update: (store, { data: ExchangeThirdPartyAuthCode }) => {
						if(provider.get().providerCode === "msft")
						{
							this.$router.push({ name: !this.settings.has_completed_wizard ? "wizard.settings" : "directory" });
						}
						else if (ExchangeThirdPartyAuthCode) {
							// replace apollo-token with an updated one containing the user's provider id
							onLogin(this.$apollo.vm.$apolloProvider.clients.defaultClient, ExchangeThirdPartyAuthCode.ExchangeThirdPartyAuthCode);
							this.$router.push({ name: !this.settings.has_completed_wizard ? "wizard.settings" : "directory" });
						} else {
							this.$message.error("Something went wrong, please try again.");
							this.$router.push({ name: "connect" });
						}
					}
				})
				.catch(e => {
					this.$message.error("Failed to connect, please try again or contact support.");
					this.$router.push({ name: "connect" });
				});
		} else {
			this.$message.error("Something went wrong, please try again.");
			this.$router.push({ name: "connect" });
		}
	}
};
</script>
